import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzHlwn75 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_75: Record<
  Exclude<PageIdWoofzHlwn75, PageIdWoofzHlwn75.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_PAGE_HLWN_75]: {
    id: PageId.SUBSCRIPTIONS_PAGE_HLWN_75,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_HLWN_75]: {
    id: PageId.CHAT_UPSELL_HLWN_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_HLWN_75]: {
    id: PageId.UPSELL_HLWN_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_HLWN_75]: {
    id: PageId.DOWNLOAD_HLWN_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
